import { atom } from "recoil";

const dashboardInterfaceStore = atom<boolean>({
	key: "dashboardIterfaceStore",
	default: false,
});

export default dashboardInterfaceStore;
